import { ClassValue } from 'clsx';
import cn from '../../app/utils/cn';

interface IOverlayProps {
  children: React.ReactNode;
  className?: ClassValue;
}
export default function Overlay({ children, className }: IOverlayProps) {
  return (
    <div
      className={cn(
        'absolute top-0 left-0 z-10 size-full backdrop-blur-sm',
        className,
      )}
    >
      {children}
    </div>
  );
}
